import { Line } from './Line';

export const ILinesApiId = Symbol.for('ILinesApi');

export interface ILinesApi {
    /**
     * Fetches all the lines operating on the given calendar day (ISO yyyy-MM-dd).
     */
    getLines(calendarDay: string): Promise<Line[]>;
}
